module.exports = __webpack_public_path__ + "img/food_select.9b82d904.png";